import React, { useMemo } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A28BFE", "#FF6B6B"];

export default function LeadSourcePie({
  sales = [],
  width = "100%",
  height = 600,     // larger default height
  maxWidth = 800,   // limit max width so chart stays centered nicely
}) {
  const data = useMemo(() => {
    const cnt = {};
    const normalize = (v) =>
      (v ?? "")
        .toString()
        .replace(/\s+/g, " ") // collapse multiple spaces/newlines/tabs into one space
        .trim() // remove leading/trailing spaces
        || "unknown";

    (sales || [])
      .filter((s) => {
        const st = (s?.status ?? "").toString().trim();
        return st !== "לא רלוונטי";
      })
      .forEach((s) => {
        const key = normalize(s.lead_source);
        cnt[key] = (cnt[key] || 0) + 1;
      });

    // build entries and sort descending by count (largest first)
    const entries = Object.entries(cnt)
      .map(([name, value]) => ({ name, value }))
      .sort((a, b) => b.value - a.value);

    return entries;
  }, [sales]);

  if (!data.length) return null;

  // compute radii based on height so the pie scales well
  const outerRadius = Math.floor(Math.min(300, height * 0.45));
  const innerRadius = 0

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width, 
      }}
    >
      <div style={{width: "100%", maxWidth, height }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              dataKey="value"
              data={data}
              outerRadius={outerRadius}
              innerRadius={innerRadius}
              label={({ name, percent }) => `${name} ${Math.round(percent * 100)}%`}
              labelLine={false}
            >
              {data.map((_, i) => (
                <Cell key={i} fill={COLORS[i % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip formatter={(v) => v.toLocaleString()} />
            {/* <Legend verticalAlign="bottom" align="center" /> */}
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}